import React, {useState, useEffect}  from 'react';
import {Container, Alert, Row, Col, Button} from 'react-bootstrap';
import {useNavigate, useParams, Link} from 'react-router-dom';
import axios from 'axios';
import {apiUrl} from '../../util/Api';
//import {isAuthenticated} from '../../util/Auth';
import {useSelector} from 'react-redux';
import {getUserAccounts} from '../../app/slices/UserSlice';
import GuardrailEditForm from './components/GuardrailEditForm';

const GuardrailDetail = () => {

  const [errors, setErrors] = useState([]);
  const [app, setApp] = useState(null);
  const [guardrail, setGuardrail] = useState(null);
  const [showEditBtn, setShowEditBtn] = useState(false);
  //const [showDeleteBtn, setShowDeleteBtn] = useState(false);

  let navigate = useNavigate();

  let {appKey, accountKey, alertId} = useParams();

  const currUserAccounts = useSelector(getUserAccounts);
  const currUserAccount = currUserAccounts.find(a => a.accountKey===accountKey);
  const currRoleId = currUserAccount ? currUserAccount.roleId : 0;


  let smWidth = 3;
  let mdWidth = 2;
  //let lgWidth = 6;

  //TODO: get users for the account
  //add buttons to edit account if role >= 2

  useEffect(() => {
    document.title = `reconify guardrail`;
    //is an account selected?
    let options = {
      appKey: appKey,
      alertId: alertId
      //accountKey: accountKey
    }
    let isAuthError = false;
    if (currRoleId > 1) {
        setShowEditBtn(true);
        //setShowDeleteBtn(true);
    }


    axios.post(apiUrl + '/guardrails/detail',
      options, {withCredentials: true})
    .then((res) => {
      if(res.data.status === 'ok') {
        if(res.data.alert !== null){
          setGuardrail(res.data.alert);   
        }
        else {
          document.title = `reconify guardrail not found`;
        }
        if(res.data.app !== null){
            setApp(res.data.app);
            document.title = `reconify guardrail: ${res.data.app?.app}`;
        }
      } else {
        let errorMsgs = [];
        let redirectToLogin = false;
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'auth-expired':
            case 'auth-error':
            case 'no-auth':
            case 'no-valid-account':
            case 'no-permissions':
              //console.log('auth expired');
              isAuthError = true;
              //navigate('/login');
              //errorMsgs.push('You have been logged out.');
              //return;
              redirectToLogin = true;
              break;
            case 'no-app':
            case 'no-valid-app':
              errorMsgs.push('The app could not be found.');
              break;
            case 'no-alert':
            case 'no-results':
                errorMsgs.push('The alert could not be found.');
                break;
            //case 'no-permissions':
            //  errorMsgs.push('You do not have permission to view this app.');
            //  break;
            default:
              errorMsgs.push('There was an error retrieving the alert.');
          }
        });
        if(redirectToLogin) {
          navigate('/login');
          return;
        }
        //don't call setErrors if not logged in as it throws an unmounted error
        if(!isAuthError) {
          setErrors(errorMsgs);
        }
      }
    })
    .catch((err) => {

    });
  },[appKey, alertId, navigate]);

  return (
    <Container fluid>
        <div>
          <h3>Guardrail Detail {app !== null ? (<span className='head-subject'>{app.app}</span>) : null}</h3>
          {
            errors.length > 0 ? (
              <Alert variant='danger'>
              {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
              </Alert>
            ) : (null)
          }
          {/*<ConfigArea roleId={currRoleId}/>*/}
          {

            guardrail !== null ? (
              <Container>
                <div className='d-flex justify-content-end'><Link className='btn btn-theme btn-md' to={`/account/${accountKey}/analytics/app/${appKey}/guardrails?alertId=${guardrail.alertId}`}>see activity</Link></div>
                
                <Row className='my-2'>
                  <Col className='detailLabel' sm={smWidth} md={mdWidth}>Tag:</Col>
                  <Col className='detailData' >{guardrail.tag}</Col>
                </Row>
                <Row className='my-2'>
                  <Col className='detailLabel' sm={smWidth} md={mdWidth}>Type:</Col>
                  <Col className='detailData'>{guardrail.typeId == 1 ? 'Prompt' : 'Response'}</Col>
                </Row>

                <Row className='my-2'>
                  <Col className='detailLabel' sm={smWidth} md={mdWidth}>Similarity Threshold:</Col>
                  <Col className='detailData'>{guardrail.threshold}</Col>
                </Row>
                <Row className='my-2'>
                  <Col className='detailLabel' sm={smWidth} md={mdWidth}>Email:</Col>
                  <Col className='detailData'>{guardrail.email}</Col>
                </Row>
                <Row className='my-2'>
                  <Col className='detailLabel' sm={smWidth} md={mdWidth}>Webhook:</Col>
                  <Col className='detailData'>{guardrail.webhook}</Col>
                </Row>
                <Row className='my-2'>
                  <Col className='detailLabel' sm={smWidth} md={mdWidth}>Status:</Col>
                  <Col className='detailData'>{guardrail.isActive == 1 ? 'Active': 'Disabled'}</Col>
                </Row>
                <Row className='my-2'>
                  <Col className='detailLabel' sm={smWidth} md={mdWidth}>Sample:</Col>
                  <Col className='detailData'><div className={`chat-bubble ${guardrail.typeId == 1 ? 'chat-bubble-in' : 'chat-bubble-out'}`}>{guardrail.sample}</div></Col>
                </Row>
                
                {showEditBtn == true ? (
                    <div className='mt-4'>
                    <GuardrailEditForm updateGuardrail={setGuardrail} guardrail={guardrail} appKey={appKey} accountKey={accountKey}/>
                    </div>
                ) : null}
                
                
              </Container>
            ) : (null)
          }
        </div>


    </Container>
  )
}

/*
const ConfigArea = (props) => {
    const [configVisible, setConfigVisible] = useState(false);
    const [errors, setErrors] = useState([]);
  
    let navigate = useNavigate();
    let {appKey} = useParams();
    let {accountKey} = useParams();
  
    //const toggleConfig = () => {
    //}
    const deleteApp = () => {
      let options = {
        appKey: appKey
      }
      let isAuthError = false;
      //gets model detail
      axios.post(apiUrl + '/apps/delete',
        options, {withCredentials: true})
      .then((res) => {
        if(res.data.status === 'ok') {
            //TODO: check if relative works, or if need full path
            //navigate('../../apps');
            navigate(`/account/${accountKey}/apps/`);
        } else {
          let errorMsgs = [];
          let redirectToLogin = false;
          res.data.errors.forEach((error, i) => {
            switch (error) {
              case 'auth-expired':
              case 'auth-error':
                case 'no-auth':
                //console.log('auth expired');
                isAuthError = true;
                //history.push('/login');
                //errorMsgs.push('You have been logged out.');
                //return;
                redirectToLogin = true;
                break;
              case 'no-app':
              case 'no-valid-app':
                errorMsgs.push('The app could not be found.');
                break;
              case 'no-permissions':
                errorMsgs.push('You do not have permission to view this app.');
                break;
              default:
                errorMsgs.push('There was an error retrieving the app.');
            }
          });
          if(redirectToLogin) {
            navigate('/login/');
            return;
          }
          //don't call setErrors if not logged in as it throws an unmounted error
          if(!isAuthError) {
            setErrors(errorMsgs);
          }
        }
      })
      .catch((err) => {
  
      });
    }
  
    if(props.roleId >= 2){
      return (
        <Container className='py-0'>
        {
          errors.length > 0 ? (
            <Alert variant='danger'>
            {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
            </Alert>
          ) : (null)
        }
        <Row className='py-0'>
          <div className="d-flex justify-content-end">
          <Button variant='link' size='sm' className='p-0' onClick={() => setConfigVisible(!configVisible)}><span className='config-btn'>&#x2699;</span></Button>
          </div>
        </Row>
        {configVisible ? (
          <Row>
            <div className="d-flex justify-content-end">
            <Button variant='danger' size='sm' onClick={deleteApp}>Delete App</Button>
            </div>
            
          </Row>
        ) : null}
        </Container>
      )
    } else {
      return null
    }
  
  }
  */

export default GuardrailDetail;
